import { useState, useCallback } from 'react';

/**
 * Hook para persistir filtros em sessionStorage.
 * Mantém filtros durante a sessão, reseta ao fechar o browser.
 *
 * @param {string} key - Chave unica do modulo (ex: 'performance', 'abc')
 * @param {*} defaultValue - Valor por defeito
 * @returns {[*, Function]} - [valor, setter]
 */
export function usePersistedState(key, defaultValue) {
  const storageKey = `filter_${key}`;

  const [value, setValue] = useState(() => {
    try {
      const stored = sessionStorage.getItem(storageKey);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setPersisted = useCallback((newValue) => {
    setValue(prev => {
      const resolved = typeof newValue === 'function' ? newValue(prev) : newValue;
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(resolved));
      } catch { /* ignore */ }
      return resolved;
    });
  }, [storageKey]);

  return [value, setPersisted];
}
